import clsx from 'clsx'

import { assetUrl } from 'utils/url'

const RUANG_DATA = {
  name: 'GTK',
  title_color: 'inverse',
  title:
    'Sumber inspirasi peningkatan kompetensi serta kinerja Guru dan Tenaga Kependidikan (GTK)',
  button: 'Mulai Jelajahi Ruang GTK',
  color: '#2A7EFB',
  icon: assetUrl('/images/ruang-gtk-v2/icons/ruang-gtk.png'),
  banner: assetUrl('/images/ruang-gtk/header-bg.jpg'),
  button_target: '_blank',
}

export function RuangHero() {
  return (
    <section
      style={{ backgroundColor: RUANG_DATA.color }}
      className={'relative flex w-full items-center'}
      aria-labelledby="ruang-hero-title"
    >
      <div className="relative flex w-full flex-col-reverse items-center justify-between lg:min-h-[460px] lg:flex-row">
        <div className="flex mx-auto w-full md:max-w-4xl lg:max-w-5xl xl:max-w-7xl 2xl:max-w-screen-2xl h-full flex-1 flex-col items-start px-5 pb-6 pt-8 sm:px-8 sm:pb-12 lg:py-0">
          <div className="flex h-12 max-w-56 justify-start">
            <img
              src={RUANG_DATA.icon}
              alt=""
              width={131}
              height={42}
              className="h-full w-auto"
              aria-hidden="true"
            />
            <span className="sr-only">Ruang GTK</span>
          </div>
          <h1
            id="ruang-hero-title"
            className={clsx(
              'mt-6 lg:max-w-lg xl:max-w-2xl',
              'font-semibold text-white',
              'text-xl',
              'sm:text-2xl',
              'lg:text-4xl'
            )}
          >
            {RUANG_DATA.title}
          </h1>

          <div className="w-full md:h-12" />
        </div>

        <img
          src={RUANG_DATA.banner}
          alt=""
          className="right-0 top-0 h-32 w-full object-cover sm:h-48 lg:absolute lg:h-full lg:max-h-[460px] lg:w-[40vw]"
        />
      </div>
    </section>
  )
}
